export default __webpack_public_path__ + "static/media/firefox.c53653b1.png";